let isRefreshing = false;
let refreshSubscribers = [];

export const getIsRefreshing = () => isRefreshing;
export const setIsRefreshing = (status) => (isRefreshing = status);

export const notifyRefreshSubscribers = (newToken) => {
  refreshSubscribers.forEach((callback) => callback(newToken));
  refreshSubscribers = [];
};

export const addRefreshSubscriber = (callback) => {
  refreshSubscribers.push(callback);
}
